module.exports = __webpack_public_path__ + "assets/img/word-study-memory.4ac3a857.png";